// src/context/OrderContext.js
import React, { createContext, useState, useContext } from "react";

const OrderContext = createContext();

export const useOrder = () => useContext(OrderContext);

export const OrderProvider = ({ children }) => {
  // States for monthly and today's orders
  const [monthlyOrders, setMonthlyOrders] = useState(0);
  const [todaysOrders, setTodaysOrders] = useState(0);
  const [totalOrders, setTotalOrders] = useState(0);
  const [orders, setOrders] = useState([]);

  // New state for bulk orders
  const [bulkOrders, setBulkOrders] = useState([]);

  // Functions to update the orders
  const updateMonthlyOrders = (count) => setMonthlyOrders(count);
  const updateTodaysOrders = (count) => setTodaysOrders(count);
  const updateTotalOrders = (count) => setTotalOrders(count);

  // Function to add a new order
  const addOrder = (newOrder) => {
    setOrders((prevOrders) => {
      // Check if the order already exists in the array based on a unique identifier (e.g., id)
      const isDuplicate = prevOrders.some((order) => order.id === newOrder.id);

      // If not a duplicate, add the new order; otherwise, return the original array
      if (!isDuplicate) {
        return [...prevOrders, newOrder];
      }
      return prevOrders;
    });
  };

  // Function to add bulk orders
  const addBulkOrders = (newBulkOrders) => {
    setBulkOrders((prevBulkOrders) => {
      // Merge new bulk orders, avoiding duplicates by checking for unique identifiers (e.g., id)
      const mergedOrders = [...prevBulkOrders];

      newBulkOrders.forEach((order) => {
        const isDuplicate = mergedOrders.some((existingOrder) => existingOrder.id === order.id);
        if (!isDuplicate) {
          mergedOrders.push(order);
        }
      });

      return mergedOrders;
    });
  };

  return (
    <OrderContext.Provider
      value={{
        monthlyOrders,
        todaysOrders,
        totalOrders,
        orders,
        bulkOrders, // Expose bulkOrders in the context
        updateMonthlyOrders,
        updateTodaysOrders,
        updateTotalOrders,
        addOrder,
        addBulkOrders, // Expose addBulkOrders in the context
      }}
    >
      {children}
    </OrderContext.Provider>
  );
};
